import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import CustomAxios from '../../../utility/customAxios';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';

export const archiveContactTemplate = async (uuid: string) => {
  const response = await CustomAxios.post(`contact_templates/${uuid}/archive`);
  return response.data;
};

interface UseArchiveContactTemplateProps {
  uuid: string;
  onSuccessCallback: () => void;
}

export function useArchiveContactTemplate({ uuid, onSuccessCallback }: UseArchiveContactTemplateProps) {
  return useMutation({
    mutationFn: () => archiveContactTemplate(uuid),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [queryKeys.allContactTemplates, uuid],
      });
      onSuccessCallback();
    },
    onError: (err: AxiosError) => {
      if (err?.response?.status === 400) {
        alert('Failed to archive the contact template. Please try again and contact support if the problem persists.');
      } else {
        console.error('Unexpected error archiving contact template:', err);
      }
    },
  });
}
